function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as h } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: r , size: a = 24  } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = h(), e = r !== null && r !== void 0 ? r : t ? o.colors.inverse : o.colors.neutralHigh, { skinName: i  } = n();
    return i.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ l("path", {
            fill: e,
            d: "M21.195 5.862L19.952 8.11A10.612 10.612 0 0122 14.419c0 1.771-.485 3.433-1.532 5.224a.716.716 0 01-.612.357.7.7 0 01-.37-.11.766.766 0 01-.238-1.023c.905-1.553 1.326-2.967 1.326-4.453a9.143 9.143 0 00-1.408-4.89l-4.019 7.267a.81.81 0 01-.02.033 3.756 3.756 0 01-.368.457 3.805 3.805 0 01-2.757 1.186 3.805 3.805 0 01-2.756-1.186c-1.518-1.581-1.518-4.157 0-5.738.132-.133.27-.257.407-.362a.591.591 0 01.064-.043l4.187-2.514a5.459 5.459 0 00-1.902-.348c-3.15 0-5.714 2.753-5.714 6.138 0 1.634.645 3.077 1.91 4.286a.767.767 0 01.047 1.052.696.696 0 01-1.01.048c-1.55-1.481-2.373-3.343-2.373-5.386 0-4.21 3.2-7.628 7.14-7.628 1.216 0 2.377.328 3.41.933l1.28-.767a8.29 8.29 0 00-4.694-1.466c-4.727 0-8.572 4.004-8.572 8.928 0 1.49.42 2.905 1.326 4.453a.76.76 0 01-.238 1.023.698.698 0 01-.983-.247C2.49 17.848 2 16.19 2 14.419 2 8.671 6.49 4 12.002 4c2.277 0 4.375.8 6.057 2.138l2.163-1.29a.692.692 0 01.86.119.766.766 0 01.113.895zm-7.451 10.371a2.06 2.06 0 00.187-.219l4.7-8.5-8.16 4.89a2.065 2.065 0 00-.215.196c-.96 1-.96 2.633 0 3.633s2.523 1 3.488 0z"
        })
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ l("path", {
            fill: e,
            d: "M11.998 5.044c6.432 0 9.83 3.334 9.83 9.64 0 1.417-.177 2.702-.53 3.823a.46.46 0 01-.036.086l-.02.043a.602.602 0 01-.54.33H3.29a.602.602 0 01-.577-.415c-.356-1.131-.538-2.43-.538-3.868 0-6.305 3.398-9.639 9.823-9.639zm8.258 12.74c.244-.919.367-1.96.367-3.1 0-5.612-2.902-8.457-8.622-8.457S3.382 9.07 3.382 14.683c0 1.143.123 2.185.364 3.1h16.51zm-7.375-2.944a1.262 1.262 0 00-.88-.356c-.692.003-1.252.552-1.25 1.23 0 .68.561 1.23 1.253 1.23a1.25 1.25 0 001.224-.972l6.364-1.83h.004l.003-.002h.002c.31-.093.49-.42.4-.731a.602.602 0 00-.748-.401l-6.372 1.832zm-.894-5.347a.595.595 0 01-.602-.591v-.799c0-.325.269-.59.602-.59.333 0 .602.265.602.59v.799a.595.595 0 01-.602.59zm-4 .361l-.577-.566a.616.616 0 00-.854 0l-.011.011c-.225.23-.219.6.01.824l.58.569a.607.607 0 00.852 0l.014-.014a.586.586 0 00-.014-.824zM5.97 13.445c.334 0 .603.263.603.591a.597.597 0 01-.603.591h-.815a.597.597 0 01-.602-.591c0-.328.269-.591.602-.591h.815zm10.011-2.756a.602.602 0 00.852-.003l.577-.566.011-.011a.583.583 0 00-.01-.824.612.612 0 00-.852 0l-.578.566-.014.014a.586.586 0 00.014.824z"
        })
    }));
}, u = s;
export { u as default };
